import React from 'react';
import { RenderAppropriate } from '../../internals/RenderAppropriate';

import { HeadingFourStyle } from '../../styles/typography/heading.styles';

interface FourProps {
    children?: React.ReactNode;
    component?: React.ElementType;
    [key: string]: any;
}

interface FourComponent extends React.FC<FourProps> {
    Style?: typeof HeadingFourStyle;
}
export const Four: FourComponent = ({ children, component: Component, ...rest }) =>
    RenderAppropriate(HeadingFourStyle, rest, children, Component);

Four.Style = HeadingFourStyle;
